const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// Inline SVG placeholder: subtle beige card with camera icon
export const IMAGE_FALLBACK =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 500' preserveAspectRatio='xMidYMid slice'>
      <rect width='400' height='500' fill='#F4F1EA'/>
      <g transform='translate(200 250)' fill='none' stroke='#C65D47' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round' opacity='0.55'>
        <rect x='-40' y='-28' width='80' height='56' rx='6'/>
        <circle cx='0' cy='2' r='16'/>
        <rect x='-14' y='-36' width='28' height='10' rx='2'/>
      </g>
      <text x='200' y='340' font-family='Georgia,serif' font-size='16' fill='#8a8580' text-anchor='middle' opacity='0.75'>Immagine non disponibile</text>
    </svg>`
  );

/**
 * Resolve a stored image reference to a full URL.
 * - "/api/files/..." → prefix with backend URL
 * - "https://..."   → return as-is (external URLs)
 * - falsy          → fallback placeholder
 */
export function resolveImg(src) {
  if (!src) return IMAGE_FALLBACK;
  if (src.startsWith("/api/")) return `${BACKEND}${src}`;
  return src;
}

/** Attach as onError to any <img> to swap to the local placeholder if the fetch fails. */
export function onImgError(e) {
  if (e?.currentTarget && e.currentTarget.src !== IMAGE_FALLBACK) {
    e.currentTarget.src = IMAGE_FALLBACK;
    e.currentTarget.onerror = null;
  }
}
